import { StylePropertyDefinition } from '../../types/common';

export const styleProperties: Array<StylePropertyDefinition> = [
	{
		gn: 'Segmented',
		dn: 'Segmented Track Background Color',
		n: 'segmentedTrackBackgroundColor',
		dv: '<backgroundColorNine>',
		cp: 'background',
		sel: '.comp.compThemeSwitcher._segmented',
		np: true,
	},
	{
		gn: 'Segmented',
		dn: 'Segmented Track Border Radius',
		n: 'segmentedTrackBorderRadius',
		dv: '8px',
		cp: 'border-radius',
		sel: '.comp.compThemeSwitcher._segmented',
		np: true,
	},
	{
		gn: 'Segmented',
		dn: 'Segmented Option Border Radius',
		n: 'segmentedOptionBorderRadius',
		dv: '6px',
		cp: 'border-radius',
		sel: '.comp.compThemeSwitcher._segmented ._option',
		np: true,
	},
	{
		gn: 'Segmented',
		dn: 'Segmented Active Option Background Color',
		n: 'segmentedActiveOptionBackgroundColor',
		dv: '<backgroundColorSeven>',
		cp: 'background',
		sel: '.comp.compThemeSwitcher._segmented ._option._active',
		np: true,
	},
	{
		gn: 'Segmented',
		dn: 'Segmented Active Option Box Shadow',
		n: 'segmentedActiveOptionBoxShadow',
		dv: '0 1px 2px rgba(0, 0, 0, 0.12)',
		cp: 'box-shadow',
		sel: '.comp.compThemeSwitcher._segmented ._option._active',
		np: true,
	},
	{
		gn: 'Toggle',
		dn: 'Toggle Track Background Color',
		n: 'toggleTrackBackgroundColor',
		dv: '<backgroundColorNine>',
		cp: 'background',
		sel: '.comp.compThemeSwitcher._toggle ._track',
		np: true,
	},
	{
		gn: 'Toggle',
		dn: 'Toggle Track Height',
		n: 'toggleTrackHeight',
		dv: '24px',
		cp: 'height',
		sel: '.comp.compThemeSwitcher._toggle ._track',
		np: true,
	},
	{
		gn: 'Toggle',
		dn: 'Toggle Track Width',
		n: 'toggleTrackWidth',
		dv: '44px',
		cp: 'width',
		sel: '.comp.compThemeSwitcher._toggle ._track',
		np: true,
	},
	{
		gn: 'Toggle',
		dn: 'Toggle On Track Background Color',
		n: 'toggleOnTrackBackgroundColor',
		dv: '<backgroundColorOne>',
		cp: 'background',
		sel: '.comp.compThemeSwitcher._toggle._on ._track',
		np: true,
	},
	{
		gn: 'Toggle',
		dn: 'Toggle Knob Background Color',
		n: 'toggleKnobBackgroundColor',
		dv: '<backgroundColorSeven>',
		cp: 'background',
		sel: '.comp.compThemeSwitcher._toggle ._knob',
		np: true,
	},
	{
		gn: 'Toggle',
		dn: 'Toggle Knob Box Shadow',
		n: 'toggleKnobBoxShadow',
		dv: '0 1px 3px rgba(0, 0, 0, 0.2)',
		cp: 'box-shadow',
		sel: '.comp.compThemeSwitcher._toggle ._knob',
		np: true,
	},
	{
		gn: 'Popover',
		dn: 'Popover Trigger Background Color',
		n: 'popoverTriggerBackgroundColor',
		dv: 'transparent',
		cp: 'background',
		sel: '.comp.compThemeSwitcher._popover ._trigger',
		np: true,
	},
	{
		gn: 'Popover',
		dn: 'Popover Trigger Border',
		n: 'popoverTriggerBorder',
		// Transparent rather than absent, so the metrics do not shift for anyone who
		// sets a visible border here. A boxed default was wrong: this control's home
		// is a toolbar, beside icon buttons that carry no chrome of their own, and a
		// ring around only the theme picker made it the loudest thing in the header.
		dv: '1px solid transparent',
		cp: 'border',
		sel: '.comp.compThemeSwitcher._popover ._trigger',
		np: true,
	},
	{
		gn: 'Popover',
		dn: 'Popover Trigger Border Radius',
		n: 'popoverTriggerBorderRadius',
		dv: '6px',
		cp: 'border-radius',
		sel: '.comp.compThemeSwitcher._popover ._trigger',
		np: true,
	},
	{
		gn: 'Popover',
		dn: 'Popover Panel Background Color',
		n: 'popoverPanelBackgroundColor',
		dv: '<backgroundColorSeven>',
		cp: 'background',
		// np is deliberate on the panel too. It is portalled to the end of the body,
		// so it is not a descendant of .comp.compThemeSwitcher and a prefixed
		// selector would never match it.
		sel: '._themeSwitcherPanel',
		np: true,
	},
	{
		gn: 'Popover',
		dn: 'Popover Panel Border Radius',
		n: 'popoverPanelBorderRadius',
		dv: '8px',
		cp: 'border-radius',
		sel: '._themeSwitcherPanel',
		np: true,
	},
	{
		gn: 'Popover',
		dn: 'Popover Panel Box Shadow',
		n: 'popoverPanelBoxShadow',
		dv: '0 10px 28px -10px rgba(10, 10, 10, 0.22), 0 1px 3px rgba(10, 10, 10, 0.07)',
		cp: 'box-shadow',
		sel: '._themeSwitcherPanel',
		np: true,
	},
	{
		gn: 'Popover',
		dn: 'Popover Panel Option Hover Background Color',
		n: 'popoverPanelOptionHoverBackgroundColor',
		dv: '<backgroundColorNine>',
		cp: 'background',
		sel: '._themeSwitcherPanel ._option:hover',
		np: true,
	},
	{
		gn: 'Popover',
		dn: 'Popover Panel Active Option Background Color',
		n: 'popoverPanelActiveOptionBackgroundColor',
		dv: '<backgroundColorNine>',
		cp: 'background',
		sel: '._themeSwitcherPanel ._option._active',
		np: true,
	},
	{
		gn: 'Label',
		dn: 'Label Font',
		n: 'themeSwitcherLabelFont',
		dv: '<primaryFont>',
		cp: 'font',
		sel: '.comp.compThemeSwitcher ._label, ._themeSwitcherPanel ._label',
		np: true,
	},
	{
		gn: 'Label',
		dn: 'Label Color',
		n: 'themeSwitcherLabelColor',
		dv: '<fontColorOne>',
		cp: 'color',
		sel: '.comp.compThemeSwitcher ._label, ._themeSwitcherPanel ._label',
		np: true,
	},
	{
		gn: 'Icon',
		dn: 'Icon Font Size',
		n: 'themeSwitcherIconFontSize',
		dv: '16px',
		cp: 'font-size',
		sel: '.comp.compThemeSwitcher ._themeIcon, ._themeSwitcherPanel ._themeIcon',
		np: true,
	},
];

export const styleDefaults = new Map<string, string>(
	styleProperties
		.filter(e => !!e.dv)
		.map(({ n: name, dv: defaultValue }) => [name, defaultValue!]),
);
